export default "__VITE_ASSET__DtkWtLpR__"